<template>
  <div>
    <v-row
      align="center"
      justify="end">
      <v-col
        cols="12"
        md="3"
        class="pt-0 pl-16">
        <div
          class="d-flex align-center pl-16">
          <div
            class="body-2 black--text font-weight-bold mr-2">
            Periode Tahun :
          </div>

          <v-select
            filled
            rounded
            dense

            placeholder="Pilih Tahun"

            hide-details

            :items="years"

            @change="fetch()"

            v-model="filter.year"
            style="border-radius: 10px; width: 120px;">
          </v-select>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col 
        cols="12" 
        md="8"
        class="pt-0">
        <v-row>
          <v-col 
            cols="12" 
            md="5">
            <v-card
              class="border-radius mb-6"
              color="#fff"
              style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
              <v-card-text>
                <div
                  class="d-flex align-start">
                  <div>
                    <div class="title black--text font-weight-bold">
                      Total Call SOS
                    </div>

                    <div 
                      class="body-2 d-flex align-center mb-12">
                      <v-icon small>mdi-file-sign</v-icon>
                      
                      <span
                        class="ml-1">
                        Total data log call
                      </span>
                    </div>
                  </div>

                  <v-spacer />

                  <div>
                    <v-img 
                      width="60"
                      height="60"
                      alt="kominfo" 
                      :src="require(`@/assets/image/time/${isDay}.png`)"
                      class="ma-auto">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="white">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>
                </div>

                <div class="d-flex align-center">
                  <div class="d-flex align-end">
                    <span 
                      class="text-h3 black--text font-weight-bold">
                      {{ list.log_call | numeric }}
                    </span>

                    <v-icon 
                      size="28" 
                      color="green" 
                      class="mb-1">
                      mdi-arrow-up-thick
                    </v-icon>
                  </div>

                  <v-spacer />

                  <div class="black--text">
                    <div v-if="clock.time.length > 0">
                      <div 
                        class="body-2" 
                        style="opacity: 60%;">
                        {{ clock.date | date }}
                      </div>

                      <div 
                        class="title font-weight-bold">
                        {{ clock.time }}
                      </div>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <v-card
              class="border-radius pa-4"
              style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
              <v-img 
                width="100"
                height="100"
                alt="vuetify" 
                :src="require('@/assets/image/doc_1.png')"
                class="ma-auto">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#58b1ed">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div class="title color-first font-weight-bold text-center mt-4 mb-2">
                Layanan
              </div>

              <div
                style="opacity: 60%;">
                <div class="text-center mb-1">
                  Kunjungi layanan yang telah
                </div>
                
                <div class="text-center">
                  disediakan Matur Dokter
                </div>
              </div>

              <div class="text-center mt-4 mb-1">
                <v-btn
                  to="/service"
                  rounded
                  elevation="0"
                  class="body-2 font-weight-bold text-capitalize white--text pl-3 pr-2"
                  width="200"
                  color="#B71C1C">
                  <div>
                    Layanan
                  </div>

                  <v-spacer />

                  <div>
                    <v-avatar color="white" size="24">
                      <v-icon size="20" color="#B71C1C">mdi-arrow-right-thick</v-icon>
                    </v-avatar>
                  </div>
                </v-btn>
              </div>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="7">
            <div
              class="mb-3">
              <v-card-text
                class="body-1 font-weight-bold black--text d-flex align-center pa-0 pr-1">
                <span>
                  Layanan Yang Di Tangani
                </span>

                <v-spacer />

                <router-link
                  to="/service">
                  <v-icon>mdi-dots-horizontal</v-icon>
                </router-link>
              </v-card-text>

              <swiper 
                class="swiper"
                ref="swiper"
                :options="{ slidesPerView: 'auto' }">
                <swiper-slide 
                  v-for="(item, index) in process.service ? 10 : list.service" 
                  :key="index" 
                  :class="index < 1 ? 'pl-1 pr-2' : index === list.service.length - 1 ? 'pr-1' : 'px-2'"
                  style="width: auto;">
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.service"
                    type="avatar"
                    tile>
                    <div>
                      <v-card v-if="!process.service && list.service.length > 0"
                        :to="`/service?code=${index}`"
                        width="100"
                        height="100"
                        style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;"
                        color="transparent"
                        class="border-radius d-flex align-center justify-center my-3">
                        <div>
                          <div class="text-center">
                            <v-avatar 
                              size="50" 
                              tile>
                              <v-img 
                                alt="kominfo" 
                                :src="item.icon"
                                class="ma-auto"
                                style="border-radius: 10px;">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      color="white">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>
                          </div>

                          <div
                            style="font-size: 8px;"
                            class="font-weight-bold text-center mt-2">
                            {{ item.text }}
                          </div>
                        </div>
                      </v-card>
                    </div>
                  </v-skeleton-loader>
                </swiper-slide>
              </swiper>
            </div>

            <v-card
              class="border-radius"
              style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
              <v-card-title 
                class="title font-weight-bold black--text pt-0">
                Grafik Layanan
              </v-card-title>

              <v-card-subtitle 
                class="body-2 d-flex align-center">
                <v-icon small>mdi-chart-line</v-icon>
                
                <span
                  class="ml-1">
                  Sampai Dengan <b>{{ clock.date | date }}</b>
                </span>
              </v-card-subtitle>

              <v-card-text
                class="pr-2"
                :class="process.graphic ? 'pa-4' : 'pa-0'">
                <v-skeleton-loader
                  class="ma-auto"
                  :loading="process.graphic"
                  type="image">
                  <div>
                    <div v-if="!process.graphic && Object.keys(list.bar).length > 0">
                      <apexchart 
                        height="258" 
                        :options="list.bar.chartOptions" 
                        :series="list.bar.series">
                      </apexchart>
                    </div>
                  </div>
                </v-skeleton-loader>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-card
          class="border-radius mt-3"
          style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
          <div 
            class="title font-weight-bold black--text pa-4 pb-0">
            <div
              class="d-flex align-center">
              <div>
                Grafik Pengunjung
              </div>

              <v-spacer />

              <div>
                {{ visit_all.pengunjung | numeric }}x
              </div>
            </div>
          </div>

          <v-card-subtitle 
            class="body-2 d-flex align-center pt-0">
            <v-icon small>mdi-chart-line</v-icon>
            
            <span
              class="ml-1">
              Sampai Dengan <b>{{ clock.date | date }}</b>
            </span>
          </v-card-subtitle>

          <v-card-text
            class="pr-2"
            :class="process.visitor ? 'pa-4' : 'pa-0'">
            <v-skeleton-loader
              class="ma-auto"
              :loading="process.visitor"
              type="image">
              <div>
                <div v-if="!process.visitor && Object.keys(list.visitor).length > 0">
                  <apexchart 
                    height="302" 
                    :options="list.visitor.chartOptions" 
                    :series="list.visitor.series">
                  </apexchart>
                </div>
              </div>
            </v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col 
        cols="12" 
        md="4">
        <v-card
          class="border-radius mb-3"
          color="#fff"
          style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
          <v-card-subtitle
            class="caption pb-0">
            Per {{ clock.date | date }}
          </v-card-subtitle>

          <v-card-title
            class="d-flex align-center pt-0">
            <div
              class="title black--text pt-0">
              Total PPD
            </div>

            <v-spacer />

            <v-menu
              bottom
              left>
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  class="body-2 cursor-pointer blue--text">
                  <v-icon>mdi-dots-horizontal</v-icon>
                </div>
              </template>

              <v-list
                dense
                class="py-0">
                <v-list-item
                  v-for="(item, index) in list.report" 
                  :key="index" 
                  :to="`/ppd?code=${index}`">
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-title>

          <v-card-text
            class="pb-3 my-2">
            <v-card
              color="#B71C1C"
              class="border-radius"
              style="box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;">
              <v-row
                justify="center">
                <v-col
                  v-for="(item, index) in process.report ? 3 : list.report" 
                  :key="index" 
                  cols="4"
                  class="white--text text-center"
                  style="border-right: 1px solid #ffffff26;">
                  <v-skeleton-loader
                    class="ma-auto mx-3"
                    :loading="process.report"
                    type="card"
                    width="78"
                    height="78"
                    tile>
                    <div>
                      <div v-if="!process.report && list.report.length > 0">
                        <v-img
                          contain
                          width="30"
                          height="30"
                          alt="vuetify"
                          :src="item.icon"
                          class="ma-auto">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="#B71C1C">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        
                        <div
                          class="caption mt-1 mb-2">
                          {{ item.text }}
                        </div>

                        <div
                          class="text-h5 font-weight-bold">
                          {{ item.count | numeric }}
                        </div>
                      </div>
                    </div>
                  </v-skeleton-loader>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>

          <v-card-text>
            <div
              class="body-1 font-weight-bold black--text">
              Detail Layanan
            </div>

            <div
              class="caption">
              <v-icon small>mdi-chart-timeline-variant</v-icon>
              Total Layanan
            </div>

            <v-row
              justify="center">
              <v-col
                v-for="(item, index) in process.data_count ? 4 : list.data_count"
                :key="index"
                cols="2">
                <v-skeleton-loader
                  class="ma-auto"
                  :loading="process.data_count"
                  type="avatar"
                  tile>
                  <div>
                    <div v-if="!process.data_count && list.data_count.length > 0">
                      <div
                        class="my-1"
                        style="font-size: 8px;">
                        {{ item.text }}
                      </div>

                      <div
                        class="text-h5 font-weight-bold black--text d-flex align-center">
                        {{ item.count | numeric }}

                        <v-badge 
                          dot 
                          class="ml-1 mb-4" 
                          color="grey">
                        </v-badge>
                      </div>
                    </div>
                  </div>
                </v-skeleton-loader>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card
          class="border-radius mt-6 mb-2"
          color="#fff"
          style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
          <v-card-text
            class="pb-0">
            <div
              class="body-1 font-weight-bold black--text">
              Pengguna
            </div>

            <v-row 
              align="center">
              <v-col 
                cols="2"
                class="title font-weight-bold black--text d-flex align-center">
                <v-icon color="black" style="margin-bottom: 2px;">mdi-account-group</v-icon>

                <span
                  class="ml-2">
                  {{ pagination.user.total_data }}
                </span>
              </v-col>

              <v-col 
                cols="10">
                <swiper 
                  class="swiper"
                  ref="swiper"
                  :options="{ slidesPerView: 'auto' }">
                  <swiper-slide 
                    v-for="(item, index) in process.user ? 20 : list.user" 
                    :key="index" 
                    :class="index < 1 ? 'pr-3' : index < list.user.length ? 'pr-3' : 'px-3'"
                    style="width: auto;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.user"
                      type="avatar"
                      tile>
                      <div>
                        <v-card v-if="!process.user && list.user.length > 0"
                          :to="`/user/${item.id}`"
                          flat
                          color="transparent"
                          class="border-radius d-flex align-center justify-center">
                          <div class="text-center">
                            <v-avatar 
                              size="45" 
                              tile>
                              <v-img 
                                alt="kominfo" 
                                :src="item.image !== '' ? item.image : require('@/assets/image/member-default.jpg')"
                                class="ma-auto"
                                style="border-radius: 10px;">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      color="white">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>
                          </div>
                        </v-card>
                      </div>
                    </v-skeleton-loader>
                  </swiper-slide>

                  <swiper-slide 
                    style="width: auto;">
                    <v-btn
                      to="/user?code=1"
                      large
                      color="#B71C1C"
                      class="text-capitalize white--text px-0"
                      min-width="45"
                      min-height="45"
                      style="border-radius: 10px; 
                            box-shadow: rgba(0, 0, 0, 0.35) 0px -50px 36px -28px inset;">
                      <v-avatar 
                        color="#B71C1C" 
                        size="30"
                        style="box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;">
                        <v-icon>mdi-arrow-right-thick</v-icon>
                      </v-avatar>
                    </v-btn>
                  </swiper-slide>
                </swiper>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card
          class="border-radius mt-6 mb-4"
          color="#fff"
          style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
          <v-card-text
            class="d-flex align-center">
            <div>
              <div
                class="body-1 font-weight-bold black--text">
                Total Pengunjung
              </div>

              <div>
                Sampai Dengan <b>{{ clock.date | date }}</b>
              </div>
            </div>

            <v-spacer/>

            <v-chip
              color="#B71C1C">
              <div
                class="body-1 font-weight-bold white--text">
                {{ list.total_visitor }}x
              </div>
            </v-chip>
          </v-card-text>
        </v-card>

        <v-row>
          <v-col
            v-for="(item, index) in process.user_count ? 4 : list.user_count"
            :key="index"
            cols="12"
            md="6">
            <v-skeleton-loader
              class="ma-auto"
              height="130"
              :loading="process.user_count"
              type="card">
              <div>
                <v-card v-if="!process.user_count && list.user_count.length > 0"
                  class="border-radius"
                  color="#fff"
                  style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
                  <v-card-text
                    class="d-flex justify-start pb-3">
                    <div
                      class="d-flex align-center">
                      <v-img
                        contain
                        width="25"
                        height="25"
                        alt="vuetify"
                        :src="item.icon">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              color="#B71C1C">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      
                      <span
                        class="body-1 font-weight-bold ml-2 black--text">
                        {{ item.text }}
                      </span>
                    </div>
                  </v-card-text>
                  
                  <v-card-text
                    class="d-flex align-end">
                    <div
                      class="text-h5 font-weight-bold black--text">
                      {{ item.count | numeric }}
                    </div>

                    <v-spacer />

                    <div
                      class="caption font-weight-light">
                      per <b>{{ clock.date | date }}</b>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col 
        cols="12" 
        md="6"
        class="pt-0">
        <v-card
          class="border-radius mt-3"
          style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
          <div 
            class="title font-weight-bold black--text pa-4 pb-0">
            <div
              class="d-flex align-center">
              <div>
                Grafik Pengguna
              </div>

              <v-spacer />

              <div>
                {{ visit_all.pengguna | numeric }}x
              </div>
            </div>
          </div>

          <v-card-subtitle 
            class="body-2 d-flex align-center pt-0">
            <v-icon small>mdi-chart-line</v-icon>
            
            <span
              class="ml-1">
              Sampai Dengan <b>{{ clock.date | date }}</b>
            </span>
          </v-card-subtitle>

          <v-card-text
            class="pr-2"
            :class="process.gp_pengguna ? 'pa-4' : 'pa-0'">
            <v-skeleton-loader
              class="ma-auto"
              :loading="process.gp_pengguna"
              type="image">
              <div>
                <div v-if="!process.gp_pengguna && Object.keys(gp_pengguna).length > 0">
                  <apexchart 
                    height="302" 
                    :options="gp_pengguna.chartOptions" 
                    :series="gp_pengguna.series">
                  </apexchart>
                </div>
              </div>
            </v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col 
        cols="12" 
        md="6"
        class="pt-0">
        <v-card
          class="border-radius mt-3"
          style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
          <div 
            class="title font-weight-bold black--text pa-4 pb-0">
            <div
              class="d-flex align-center">
              <div>
                Grafik Konsultasi
              </div>

              <v-spacer />

              <div>
                {{ visit_all.konsultasi | numeric }}x
              </div>
            </div>
          </div>

          <v-card-subtitle 
            class="body-2 d-flex align-center pt-0">
            <v-icon small>mdi-chart-line</v-icon>
            
            <span
              class="ml-1">
              Sampai Dengan <b>{{ clock.date | date }}</b>
            </span>
          </v-card-subtitle>

          <v-card-text
            class="pr-2"
            :class="process.gp_konsultasi ? 'pa-4' : 'pa-0'">
            <v-skeleton-loader
              class="ma-auto"
              :loading="process.gp_konsultasi"
              type="image">
              <div>
                <div v-if="!process.gp_konsultasi && Object.keys(gp_konsultasi).length > 0">
                  <apexchart 
                    height="302" 
                    :options="gp_konsultasi.chartOptions" 
                    :series="gp_konsultasi.series">
                  </apexchart>
                </div>
              </div>
            </v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      class="mb-4">
      <v-col 
        cols="12" 
        md="6"
        class="pt-0">
        <v-card
          class="border-radius mt-3"
          style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
          <div 
            class="title font-weight-bold black--text pa-4 pb-0">
            <div
              class="d-flex align-center">
              <div>
                Grafik Informasi kesehatan
              </div>

              <v-spacer />

              <div>
                {{ visit_all.informasi | numeric }}x
              </div>
            </div>
          </div>

          <v-card-subtitle 
            class="body-2 d-flex align-center pt-0">
            <v-icon small>mdi-chart-line</v-icon>
            
            <span
              class="ml-1">
              Sampai Dengan <b>{{ clock.date | date }}</b>
            </span>
          </v-card-subtitle>

          <v-card-text
            class="pr-2"
            :class="process.gp_informasi ? 'pa-4' : 'pa-0'">
            <v-skeleton-loader
              class="ma-auto"
              :loading="process.gp_informasi"
              type="image">
              <div>
                <div v-if="!process.gp_informasi && Object.keys(gp_informasi).length > 0">
                  <apexchart 
                    height="302" 
                    :options="gp_informasi.chartOptions" 
                    :series="gp_informasi.series">
                  </apexchart>
                </div>
              </div>
            </v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col 
        cols="12" 
        md="6"
        class="pt-0">
        <v-card
          class="border-radius mt-3"
          style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
          <div 
            class="title font-weight-bold black--text pa-4 pb-0">
            <div
              class="d-flex align-center">
              <div>
                Grafik Call SOS
              </div>

              <v-spacer />

              <div>
                {{ visit_all.sos | numeric }}x
              </div>
            </div>
          </div>

          <v-card-subtitle 
            class="body-2 d-flex align-center pt-0">
            <v-icon small>mdi-chart-line</v-icon>
            
            <span
              class="ml-1">
              Sampai Dengan <b>{{ clock.date | date }}</b>
            </span>
          </v-card-subtitle>

          <v-card-text
            class="pr-2"
            :class="process.gp_sos ? 'pa-4' : 'pa-0'">
            <v-skeleton-loader
              class="ma-auto"
              :loading="process.gp_sos"
              type="image">
              <div>
                <div v-if="!process.gp_sos && Object.keys(gp_sos).length > 0">
                  <apexchart 
                    height="302" 
                    :options="gp_sos.chartOptions" 
                    :series="gp_sos.series">
                  </apexchart>
                </div>
              </div>
            </v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        selected: {
          menu: 0
        },

        clock: {
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          time: ''
        },

        filter: {
          year: ''
        },

        list: {
          user: [],
          bar: {},
          user_count: [],
          report: [],
          data_count: [],
          service: [
            {
              text: 'Puskesmas',
              value: 'puskesmas',
              icon: require('@/assets/image/service/puskesmas.png')
            },
            {
              text: 'Klinik',
              value: 'clinic',
              icon: require('@/assets/image/service/klinik.png')
            },
            {
              text: 'Rumah Sakit',
              value: 'hospital',
              icon: require('@/assets/image/service/rumah_sakit.png')
            },
            {
              text: 'Laboratorium',
              value: 'laboratory',
              icon: require('@/assets/image/service/laboratorium.png')
            },
            {
              text: 'Ambulan',
              value: 'ambulance',
              icon: require('@/assets/image/service/ambulan.png')
            },
            {
              text: 'Apotik',
              value: 'drugstore',
              icon: require('@/assets/image/service/apotik.png')
            },
            {
              text: 'Stok Darah',
              value: 'blood',
              icon: require('@/assets/image/service/stok_darah.png')
            }
          ],
          log_call: 0,
          visitor: {},
          total_visitor: 0
        },
        pagination: {
          user: {}
        },

        gp_pengguna: {},
        gp_sos: {},
        gp_konsultasi: {},
        gp_informasi: {},

        visit_all: {
          pengunjung: 0,
          pengguna: 0,
          konsultasi: 0,
          informasi: 0,
          sos: 0
        },

        picker: {
          start: false,
          end: false
        },

        form: {
          start: '',
          end: ''
        },

        process: {
          user: false,
          log_call: false,
          graphic: false,
          user_count: false,
          report: false,
          data_count: false,
          visitor: false,

          gp_pengguna: false,
          gp_sos: false,
          gp_konsultasi: false,
          gp_informasi: false
        }
      }
    },
    components: {
      
    },
    computed: {
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },

      years () {
        let max = new Date().getFullYear(), min = max - 3, years = [
          {
            text: 'Semua',
            value: ''
          }
        ]

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    watch: {
      
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        setInterval(this.updateTime, 1000)

        this.fetchUser()
        this.fetchLogcall()
        this.fetchData_Count()
        this.fetchGraphic()
        this.fetchUser_Count()
        this.fetchReport()
        this.fetchVisitor()

        this.fetch_Gp_Pengguna()
        this.fetch_Gp_Sos()
        this.fetch_Gp_Konsultasi()
        this.fetch_Gp_Informasi()
      },

      async fetchUser () {
        this.process.user = true

        let params = {
          limit: 20,
          level: 'user'
        }

        await get('user', { params })
        .then(response => {
          let res = response.data

          this.process.user = false
            
          if (res.code === 200) {
            this.list.user = res.data
            this.pagination.user = res.pagination
          }
        })
      },

      async fetchLogcall () {
        this.process.log_call = true

        await get('sos_call/log')
        .then(response => {
          let res = response.data

          this.process.log_call = false

          if (res.code === 200) {
            let data = res.pagination

            this.list.log_call = data.total_data
          }
        })
      },

      async fetchData_Count () {
        this.process.data_count = true

        let params = {
          year: this.filter.year
        }

        await get('dashboard/data_count', { params })
        .then(response => {
          let res = response.data

          this.process.data_count = false

          if (res.code === 200) {
            let data = res.data.data_count

            this.list.data_count = [
              {
                text: 'Puskesmas',
                value: 'puskesmas',
                icon: require('@/assets/image/service/puskesmas.png'),
                count: data.puskesmas
              },
              {
                text: 'Klinik',
                value: 'clinic',
                icon: require('@/assets/image/service/klinik.png'),
                count: data.klinik
              },
              {
                text: 'Rumah Sakit',
                value: 'hospital',
                icon: require('@/assets/image/service/rumah_sakit.png'),
                count: data.rumah_sakit
              },
              {
                text: 'Laboratorium',
                value: 'laboratory',
                icon: require('@/assets/image/service/laboratorium.png'),
                count: data.laboratorium
              },
              {
                text: 'Ambulan',
                value: 'ambulance',
                icon: require('@/assets/image/service/ambulan.png'),
                count: data.ambulance
              },
              {
                text: 'Apotik',
                value: 'drugstore',
                icon: require('@/assets/image/service/apotik.png'),
                count: data.apotek
              }
            ]
          }
        })
      },

      async fetchGraphic () {
        this.process.graphic = true

        let params = {
          year: this.filter.year
        }

        let chart_arr = []

        await get('dashboard/graphic_data', { params })
        .then(response => {
          let res = response.data

          this.process.graphic = false

          if (res.code === 200) {
            res.data.graphic_data.home_care.name = 'home care'

            chart_arr.push(
              res.data.graphic_data.pppk,
              res.data.graphic_data.gadar,
              res.data.graphic_data.home_care,
              res.data.graphic_data.konsultasi
            )

            this.list.bar = {
              series: chart_arr,
              chartOptions: {
                chart: {
                  animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  }
                },
                stroke: {
                  width: 3,
                  curve: 'smooth'
                },
                dataLabels: {
                  enabled: false
                },
                colors: ['#9C27B0', '#F44336', '#2196F3', '#4CAF50'],
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return Math.round(value)
                    }
                  }
                },
                xaxis: {
                  categories: res.data.month
                }
              }
            }
          }
        })
      },

      async fetchReport () {
        this.process.report = true

        let params = {
          year: this.filter.year
        }

        await get('dashboard/laporan_count', { params })
        .then(response => {
          let res = response.data

          this.process.report = false

          if (res.code === 200) {
            let data = res.data.laporan_count

            this.list.report = [
              {
                text: 'PPPK',
                value: 'pppk',
                icon: require('@/assets/image/service/pppk.png'),
                count: data.pppk
              },
              {
                text: 'Gawat Darurat',
                value: 'gadar',
                icon: require('@/assets/image/service/gadar_2.png'),
                count: data.gadar
              },
              {
                text: 'Home Care',
                value: 'homecare',
                icon: require('@/assets/image/service/home_care.png'),
                count: data.home_care
              }
            ]
          }
        })
      },

      async fetchUser_Count () {
        this.process.user_count = true

        let params = {
          year: this.filter.year
        }

        await get('dashboard/user_count', { params })
        .then(response => {
          let res = response.data

          this.process.user_count = false

          if (res.code === 200) {
            let data = res.data.user_count

            this.list.user_count = [
              {
                text: 'Dokter',
                value: 'doctor',
                icon: require('@/assets/image/service/dokter.png'),
                count: data.doctor
              },
              {
                text: 'Puskesmas',
                value: 'puskesmas',
                icon: require('@/assets/image/service/user_puskesmas.png'),
                count: data.puskesmas
              },
              {
                text: 'Public Service Center',
                value: 'psc',
                icon: require('@/assets/image/service/user_psc.png'),
                count: data.psc
              },
              {
                text: 'Operator',
                value: 'operator',
                icon: require('@/assets/image/service/operator.png'),
                count: data.operator
              }
            ]
          }
        })
      },

      async fetchVisitor () {
        this.process.visitor = true

        let params = {
          year: this.filter.year
        }

        await get('dashboard/visitor_graphic_data', { params })
        .then(response => {
          let res = response.data

          this.process.visitor = false

          if (res.code === 200) {
            let data = res.data

            this.list.total_visitor = data.visit_all

            this.list.visitor = {
              series: [data.graphic_data],
              chartOptions: {
                chart: {
                  animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  }
                },
                stroke: {
                  width: 3,
                  curve: 'smooth'
                },
                dataLabels: {
                  enabled: false
                },
                colors: ['#4CAF50'],
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return Math.round(value)
                    }
                  }
                },
                xaxis: {
                  categories: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
                }
              }
            }

            this.visit_all.pengunjung = data.visit_all
          }
        })
      },

      updateTime () {
        let cd = new Date()

        this.clock.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2)
      },
      zeroPadding (num, digit) {
        let zero = ''

        for(let i = 0; i < digit; i++) {
          zero += '0'
        }
        return (zero + num).slice(-digit)
      },


      // new spbe
      async fetch_Gp_Pengguna () {
        this.process.gp_pengguna = true

        let params = {
          year: this.filter.year
        }

        await get('dashboard/user_graphic_data', { params })
        .then(response => {
          let res = response.data

          this.process.gp_pengguna = false

          if (res.code === 200) {
            this.gp_pengguna = {
              series: [res.data.graphic_data],
              chartOptions: {
                chart: {
                  animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  }
                },
                stroke: {
                  width: 3,
                  curve: 'smooth'
                },
                dataLabels: {
                  enabled: false
                },
                colors: ['#4CAF50'],
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return Math.round(value)
                    }
                  }
                },
                xaxis: {
                  categories: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
                }
              }
            }

            this.visit_all.pengguna = res.data.visit_all
          }
        })

      },
      async fetch_Gp_Sos () {
        this.process.gp_sos = true

        let params = {
          year: this.filter.year
        }

        await get('dashboard/call_graphic_data', { params })
        .then(response => {
          let res = response.data

          this.process.gp_sos = false

          if (res.code === 200) {
            this.gp_sos = {
              series: [res.data.graphic_data],
              chartOptions: {
                chart: {
                  animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  }
                },
                stroke: {
                  width: 3,
                  curve: 'smooth'
                },
                dataLabels: {
                  enabled: false
                },
                colors: ['#4CAF50'],
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return Math.round(value)
                    }
                  }
                },
                xaxis: {
                  categories: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
                }
              }
            }

            this.visit_all.sos = res.data.visit_all
          }
        })
      },
      async fetch_Gp_Konsultasi () {
        this.process.gp_konsultasi = true

        let params = {
          year: this.filter.year
        }

        await get('dashboard/konsultasi_graphic_data', { params })
        .then(response => {
          let res = response.data

          this.process.gp_konsultasi = false

          if (res.code === 200) {
            this.gp_konsultasi = {
              series: [res.data.graphic_data],
              chartOptions: {
                chart: {
                  animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  }
                },
                stroke: {
                  width: 3,
                  curve: 'smooth'
                },
                dataLabels: {
                  enabled: false
                },
                colors: ['#4CAF50'],
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return Math.round(value)
                    }
                  }
                },
                xaxis: {
                  categories: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
                }
              }
            }

            this.visit_all.konsultasi = res.data.visit_all
          }
        })
      },
      async fetch_Gp_Informasi () {
        this.process.gp_informasi = true

        let params = {
          year: this.filter.year
        }

        await get('dashboard/konsultasi_informasi_graphic_data', { params })
        .then(response => {
          let res = response.data

          this.process.gp_informasi = false

          if (res.code === 200) {
            this.gp_informasi = {
              series: [res.data.graphic_data],
              chartOptions: {
                chart: {
                  animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  }
                },
                stroke: {
                  width: 3,
                  curve: 'smooth'
                },
                dataLabels: {
                  enabled: false
                },
                colors: ['#4CAF50'],
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return Math.round(value)
                    }
                  }
                },
                xaxis: {
                  categories: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
                }
              }
            }

            this.visit_all.informasi = res.data.visit_all
          }
        })
      }
    }
  }
</script>